module.exports = __webpack_public_path__ + "static/media/cabesp.0fca9c08.jpg";